var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E7DD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24323_40261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24323_40261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 22.1878L10.7917 24.0628C10.625 24.2295 10.4306 24.3094 10.2083 24.3024C9.98612 24.2955 9.79168 24.2087 9.62501 24.042C9.47223 23.8753 9.39237 23.6809 9.38543 23.4587C9.37848 23.2364 9.45834 23.042 9.62501 22.8753L11.5 21.0003H10.4583C10.2222 21.0003 10.0243 20.9205 9.86459 20.7607C9.70487 20.601 9.62501 20.4031 9.62501 20.167C9.62501 19.9309 9.70487 19.733 9.86459 19.5732C10.0243 19.4135 10.2222 19.3337 10.4583 19.3337H13.5C13.7361 19.3337 13.934 19.4135 14.0938 19.5732C14.2535 19.733 14.3333 19.9309 14.3333 20.167V23.2087C14.3333 23.4448 14.2535 23.6427 14.0938 23.8024C13.934 23.9621 13.7361 24.042 13.5 24.042C13.2639 24.042 13.066 23.9621 12.9063 23.8024C12.7465 23.6427 12.6667 23.4448 12.6667 23.2087V22.1878ZM10.1667 17.667C9.93057 17.667 9.73265 17.5871 9.57293 17.4274C9.4132 17.2677 9.33334 17.0698 9.33334 16.8337V9.33366C9.33334 8.87533 9.49654 8.48296 9.82293 8.15658C10.1493 7.83019 10.5417 7.66699 11 7.66699H17.6667L22.6667 12.667V22.667C22.6667 23.1253 22.5035 23.5177 22.1771 23.8441C21.8507 24.1705 21.4583 24.3337 21 24.3337H16.8333C16.5972 24.3337 16.3993 24.2538 16.2396 24.0941C16.0799 23.9344 16 23.7364 16 23.5003C16 23.2642 16.0799 23.0663 16.2396 22.9066C16.3993 22.7469 16.5972 22.667 16.8333 22.667H21V13.5003H17.6667C17.4306 13.5003 17.2326 13.4205 17.0729 13.2607C16.9132 13.101 16.8333 12.9031 16.8333 12.667V9.33366H11V16.8337C11 17.0698 10.9201 17.2677 10.7604 17.4274C10.6007 17.5871 10.4028 17.667 10.1667 17.667Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportChatIcon);
export default __webpack_public_path__ + "static/media/export-chat-icon.b1ac6454f211057c2931d9c23f583069.svg";
export { ForwardRef as ReactComponent };